import { useEffect, useState } from 'react';

export const useHeightFromParentsMaxHeight = ({ defaultHeight }: { defaultHeight: number }) => {
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (containerRef) {
      containerRef.style.height = `${defaultHeight}px`;
    }

    const parentHeight = containerRef?.parentElement?.clientHeight;

    if (containerRef && parentHeight) {
      containerRef.style.height = `${Math.min(parentHeight, defaultHeight)}px`;
    }
  }, [containerRef, defaultHeight]);

  return { setContainerRef };
};
